<template>
  <v-form ref="form" class="">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <v-col cols="12" sm="12">
        <v-text-field
          v-model="entry.identifier"
          v-bind="getObject('identifier')"
          label="Indentificador"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>
      <v-col cols="12" sm="8">
        <v-autocomplete
          v-model="entry.harvestId"
          v-bind="getObject('harvestId')"
          label="Safra"
          :items="extraData.accountContext.allHarvests"
          item-value="id"
          item-text="name"
          autocomplete="off"
          @input="selectHarvest(true)"
          :disabled="readOnly"
        >
          <template v-slot:append-outer>
            <HarvestNew
              :inlineAddButton="true"
              @entry-created="harvestCreated"
              modelNameSingular="Safra"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="4">
        <v-switch 
          v-model="entry.enabled" 
          inset 
          :label="entry.enabled ? 'Ativo' : 'Inativo'"
          :disabled="readOnly">
        </v-switch>
      </v-col>

      <v-col cols="12" sm="12" >
        <v-autocomplete
          v-model="entry.fieldId"
          v-bind="getObject('fieldId')"
          label="Talhão"
          :items="fieldsForHarvestList"
          item-value="id"
          item-text="name"
          autocomplete="off"
          @input="selectField"
          :hint="entry.field ? ('Área: ' + numberToDecimal(entry.field.area) + ' ha, Área Útil Disponível na Safra ' + entry.harvest.name + ': ' + numberToDecimal(entry.field.availableUsefulArea) + ' ha') : ''"
          persistent-hint
          :loading="fieldListLoading"
          :disabled="!entry.harvestId || readOnly"
        >
          <template v-slot:item="data">
            <v-list-item-content>
              <v-list-item-title>{{data.item.name}}</v-list-item-title>
              <v-list-item-subtitle>Área: {{numberToDecimal(data.item.area)}} ha, Área Útil Disponível na Safra {{entry.harvest.name}}: {{numberToDecimal(data.item.availableUsefulArea)}} ha</v-list-item-subtitle>
            </v-list-item-content>
          </template>

          <template v-slot:append-outer>
            <FieldNew
              :inlineAddButton="true"
              @entry-created="fieldCreated" 
              modelNameSingular="Talhão"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-autocomplete
          v-model="entry.cultureId"
          v-bind="getObject('cultureId')"
          label="Cultura"
          :items="extraData.accountContext.allCulturesForAccount"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <MaskedTextField
          v-bind="getObject('area')"
          :inputData.sync="entry.area"
          mask-type="currency"
          label="Área"
          suffix="ha"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <DateField
          :inputData.sync="entry.startPrediction"
          v-bind="getObject('startPrediction')"
          label="Início Estimado"
          :hasTodayButton="true"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <DateField
          :inputData.sync="entry.expectedEndDate"
          v-bind="getObject('expectedEndDate')"
          label="Término Estimado"
          :hasTodayButton="true"
          :disabled="readOnly"
        />
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import HarvestNew from "@models/harvests/new.vue"
import FieldNew from "@models/fields/new.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      fieldListLoading: false,
      fieldsForHarvestList: [],
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    DateField: DateField,
    HarvestNew: HarvestNew,
    FieldNew: FieldNew,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    if (this.entry.id) {
      this.selectHarvest();
      this.selectField();
    }
  },
  mounted() {
  },
  methods: {
    selectField: function() {
      this.entry.field = this.fieldsForHarvestList.find(obj => obj.id == this.entry.fieldId);
    },
    selectHarvest: function(clearField=false) {
      if (this.entry.harvestId) {
        if (clearField) {
          this.entry.fieldId = null;
        }
        
        this.entry.harvest = this.extraData.accountContext.allHarvests.find(obj => obj.id == this.entry.harvestId);
        this.fieldListLoading = true;
        this.$apollo
          .query({
            query: ALL_FIELDS_FOR_HARVEST_QUERY,
            fetchPolicy: "no-cache",
            variables: {
              harvestId: this.entry.harvestId
            }
          })
          .then(response => {
            // console.log("response dos stocks", response)
            this.fieldsForHarvestList = response.data.groundContext.allFieldsForHarvest;

            if(!this.entry.fieldId && this.fieldsForHarvestList.length == 1) {
              this.entry.fieldId = this.fieldsForHarvestList[0].id;
              this.entry.field = this.fieldsForHarvestList[0];
            }

          })
          .catch(response => console.log(response))
          .finally(() => (this.fieldListLoading = false));
      }
    },
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
    harvestCreated: function(harvest) {
      if (harvest) {
        this.extraData.accountContext.allHarvests.unshift(harvest);
        this.entry.harvestId = harvest.id;
        this.entry.harvest = harvest;
        this.selectHarvest(true);
      }
    },
    fieldCreated: function(field) {
      if (field){
        this.fieldsForHarvestList.unshift(field);
        this.entry.fieldId = field.id;
        this.entry.field = field;
        this.entry.field.availableUsefulArea = this.entry.field.area;
      }
      // if (this.entry.harvestId) {
      //   this.selectHarvest(true);
      // }
    },
  }
};

const ALL_FIELDS_FOR_HARVEST_QUERY = gql `
  query ($harvestId: ID!) {
    groundContext {
      allFieldsForHarvest(harvestId: $harvestId) {
        id
        name
        area
        usefulArea
        availableUsefulArea
      }
    }
  }
`;

</script>

<style scoped></style>
